import React from 'react';
import {
  RELEASE_NOTES_API_LIST,
  RELEASE_NOTES_NAVIGATE_PATHS,
} from '../../constants';
import {
  ContentGrid,
  DocContentLink,
  DocsContent,
  ReleaseNotesList,
  ReleaseNotesListItem,
  TableOfContentsWrapper,
  SectionTitle,
  TabSectionsContainer,
} from '../../styles';
import { TableOfContents } from '../TableOfContents/TableOfContents';
import { getDocsRouteFromDocPath } from '../../utils';

interface ReleaseNotesTabContentProps {
  selectedTabId: string;
}

export function ReleaseNotesTabContent({
  selectedTabId,
}: ReleaseNotesTabContentProps) {
  return (
    <ContentGrid>
      <DocsContent>
        <TabSectionsContainer>
          <section>
            <SectionTitle variant="h5">Table of Contents</SectionTitle>
            <ReleaseNotesList>
              {RELEASE_NOTES_API_LIST.map(item => {
                const navigatePath = RELEASE_NOTES_NAVIGATE_PATHS[item];
                const route = navigatePath
                  ? getDocsRouteFromDocPath(navigatePath, 'release-notes')
                  : undefined;

                return (
                  <ReleaseNotesListItem key={item}>
                    {route ? (
                      <DocContentLink to={route}>{item}</DocContentLink>
                    ) : (
                      <span>{item}</span>
                    )}
                  </ReleaseNotesListItem>
                );
              })}
            </ReleaseNotesList>
          </section>
        </TabSectionsContainer>
      </DocsContent>

      <TableOfContentsWrapper>
        <TableOfContents selectedTabId={selectedTabId} />
      </TableOfContentsWrapper>
    </ContentGrid>
  );
}
